import { Component, Input, OnInit } from "@angular/core";
import { eAccountType, eCreativeStatusBuild } from "@Workspace/_generated/enums";
import { ICreativeDto } from "@Workspace/_generated/interfaces";


@Component({
    selector: 'creative-budget',
    templateUrl: './creative-budget.component.html',
    styleUrls: ['./creative-budget.component.scss']
})

export class CreativeBudgetComponent implements OnInit {
    
    @Input() creative: ICreativeDto;
    isEditingBudget = false;
    editableBudget!: number;
    enumCreativeStatusBuild = eCreativeStatusBuild;

    constructor() {}
    
    ngOnInit(): void {
    }

    editBudget() {
        this.editableBudget = this.creative.budget;
        this.isEditingBudget = true;
    }

    saveBudget() {
        this.creative.budget = this.editableBudget;
        this.isEditingBudget = false;
    }

    cancelBudget() {
        this.isEditingBudget = false;
    }

    isEditDisabled(row: ICreativeDto): boolean {
        return row.creativeStatusBuildId === eCreativeStatusBuild.Send_to_API;
    }
}